import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment';

import { SkalReport } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ReportApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES
    ? `${this.env.APIM_BASE_URL}/arable-service/advice/`
    : `${this.env.API_BASE_URL}/service/field-report/secure/`;

  getSkalReport(cropYear: number) {
    const path = this.env.USE_ARABLE_SERVICE_FIELD_REPORT_ROUTES ? 'skal-report' : 'skalreport';
    return this.http.get<SkalReport>(`${this.baseUrl}${path}?cropYear=${cropYear}`);
  }
}
